import { Navigate } from 'react-router-dom';
import { defaultRoute } from 'app/config';
import { Signin } from 'views/signin';
import { Dashboard } from 'views/dashboard';
import { Accounts } from 'views/accounts';
import { Users } from 'views/users';
import { Feedback } from 'views/feedback';
import { Logs } from 'views/log/list';
import { LogDetail } from 'views/log/detail';
import { EventGroups } from 'views/event/groups';
import { Events } from 'views/event/list';
import { EventDetail } from 'views/event/detail';
import { UserDetail } from 'views/users/detail';
import { AccountDetail } from 'views/accounts/detail';
import { Insights } from 'views/insights';
import { Dashboards } from 'views/dashboards';
import { Admin } from 'views/admin';
import { SupportTools } from 'views/support';
import { ProductEvents } from 'views/product-events';
import { ProductEventDetail } from 'views/product-events/detail';
import { Referrals } from 'views/referrals';
import { Credits } from 'views/credits';

const Routes = [
  {
    path: '/',
    view: () => <Navigate to={ defaultRoute() } replace />,
    layout: 'auth',
    title: 'Mission Control'
  },
  {
    path: '/signin',
    view: Signin,
    layout: 'auth',
    title: 'Mission Control'
  },
  {
    path: '/dashboard',
    view: Dashboard,
    layout: 'app',
    permission: 'master',
    title: 'Mission Control'
  },
  {
    path: '/accounts',
    view: Accounts,
    layout: 'app',
    permission: 'master',
    title: 'Accounts'
  },
  {
    path: '/accounts/:id',
    view: AccountDetail,
    layout: 'app',
    permission: 'master',
    title: 'Account Details'
  },
  {
    path: '/accounts/:id/:tab',
    view: AccountDetail,
    layout: 'app',
    permission: 'master',
    title: 'Account Details'
  },
  {
    path: '/users',
    view: Users,
    layout: 'app',
    permission: 'master',
    title: 'Users'
  },
  {
    path: '/users/:id',
    view: UserDetail,
    layout: 'app',
    permission: 'master',
    title: 'User Details'
  },
  {
    path: '/users/:id/:tab',
    view: UserDetail,
    layout: 'app',
    permission: 'master',
    title: 'User Details'
  },
  {
    path: '/feedback',
    view: Feedback,
    layout: 'app',
    permission: 'master',
    title: 'User Feedback'
  },
  {
    path: '/logs',
    view: Logs,
    layout: 'app',
    permission: 'master',
    title: 'App Logs'
  },
  {
    path: '/logs/events',
    view: Logs,
    layout: 'app',
    permission: 'master',
    title: 'App Logs'
  },
  {
    path: '/logs/errors',
    view: Logs,
    layout: 'app',
    permission: 'master',
    title: 'App Logs'
  },
  {
    path: '/logs/:id',
    view: LogDetail,
    layout: 'app',
    permission: 'master',
    title: 'Log Detail'
  },
  {
    path: '/events',
    view: EventGroups,
    layout: 'app',
    permission: 'master',
    title: 'Events'
  },
  {
    path: '/events/:group',
    view: Events,
    layout: 'app',
    permission: 'master',
    title: 'Event'
  },
  {
    path: '/events/:group/:id',
    view: EventDetail,
    layout: 'app',
    permission: 'master',
    title: 'Event Detail'
  },
  {
    path: '/insights',
    view: Insights,
    layout: 'app',
    permission: 'master',
    title: 'Insights'
  },
  {
    path: '/dashboards',
    view: Dashboards,
    layout: 'app',
    permission: 'master',
    title: 'Dashboards'
  },
  {
    path: '/admin',
    view: Admin,
    layout: 'app',
    permission: 'master',
    title: 'Admin'
  },
  {
    path: '/support',
    view: SupportTools,
    layout: 'app',
    permission: 'master',
    title: 'Inbox',
    feature: 'intercom'
  },
  {
    path: '/product-events',
    view: ProductEvents,
    layout: 'app',
    permission: 'master',
    title: 'Product Events'
  },
  {
    path: '/product-events/:name',
    view: ProductEventDetail,
    layout: 'app',
    permission: 'master',
    title: 'Product Events'
  },
  {
    path: '/credits',
    view: Credits,
    layout: 'app',
    permission: 'master',
    title: 'Pro Credits'
  },
  {
    path: '/referrals',
    view: Referrals,
    layout: 'app',
    permission: 'master',
    title: 'Referrals'
  },

]

export default Routes;